var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'guideline-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      savingFlag: false,
      guideline: {
        guideline_content: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        guideline_content: !!this.guideline.guideline_content,
        not_input: !!this.guideline.guideline_content
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('GUIDELINE_CREATE',
          { data: this.guideline, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/guidelines', query: { type: this.$router.currentRoute.query.type}})
    },
    half: function () {
      this.guideline.guideline_content = utils.emHalf(this.guideline.guideline_content)
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/guidelines')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/guideline-new.js